import React from 'react';
import { useSelector } from 'react-redux';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import { careerAndSeasonStatsNavSelector, careerAndSeasonStatsSortSelector } from '../../../../../../store/js/modules/statspro/career-and-season-stats/selectors';

/**
 * @returns {JSX.Element} Component.
 */
export const Heading = () => {
    const nav = useSelector( careerAndSeasonStatsNavSelector );
    const seasons = useSelector( state => state.seasons[ `competition_${ nav.competition.id }` ]?.list ?? [] );
    const season = seasons.find( item => item.id === nav.season.id );
    const sort = useSelector( careerAndSeasonStatsSortSelector );

    return (
        <>
            { nav.season.id === -1 ?
                <>  
                    <strong>{ ( sort.columnId === 'year' || sort.columnId === 'round' ) ? getTranslation( 'label.stats.by' ) + ' ' + getTranslation( 'label.stats.year' ) : getTranslation( `label.statsLeaders.${ sort.columnId }.name` ) }</strong> - { getTranslation( 'label.stats.career' ) }
                </> :
                <>
                    <strong>{ ( sort.columnId === 'round' || sort.columnId === 'year' ) ? getTranslation( 'label.stats.by' ) + ' ' + getTranslation( 'label.stats.round' ) : getTranslation( `label.statsLeaders.${ sort.columnId }.name` ) }</strong> - { season.name }
                </>
            }
        </>
    );
};